const MarkdownHelper = {
  _list: (e, ref, currentNoteText, changeNote) => {
    switch (e.keyCode) {
      case 13:
        let start = ref.selectionStart,
        end = ref.selectionEnd,
        noteText = currentNoteText;

        let lines = noteText.split('\n');
        let lineNumber = noteText.slice(0, start).split('\n').length - 1;

        if (lines[lineNumber].match(/^[*|+|-]\s$/)) {
          e.preventDefault();
          lines[lineNumber] = "";
          if (lineNumber === (lines.length - 1)) {
            start += 6;
            end += 6;
          } else {
            start -= 2;
            end -= 2;
          }
        } else if (lines[lineNumber].match(/^[*|+|-]$/)) {
          e.preventDefault();
          lines[lineNumber] = "";
          if (lineNumber === (lines.length - 1)) {
            start += 5;
            end += 5;
          } else {
            start -= 1;
            end -= 1;
          }
        } else if (lines[lineNumber].match(/^[*|+|-]\s.*$/)) {
          e.preventDefault();
          var subtract = 0;
          for (var i = 0; i < lineNumber; i++) {
            subtract += lines[i].length;
          }
          subtract += lineNumber;
          var l = lines[lineNumber].length;
          lines = lines.slice(0, lineNumber)
          .concat([lines[lineNumber].slice(0, (start - subtract))])
          .concat([lines[lineNumber][0] + " " + lines[lineNumber].slice(start - subtract)])
          .concat(lines.slice(lineNumber + 1));

          start = 3 + l + subtract;
          end = 3 + l + subtract;
        }
        noteText = lines.join("\n");
        changeNote && changeNote(noteText, start, end);
        break;
      default:
        break;
    }
  }
};

export default MarkdownHelper;
